<template>
  <div class="newsletter-page-container">
    <v-container class="newsletter-page-content">
      <NewsletterSignup />
    </v-container>
  </div>
</template>

<script>
import NewsletterSignup from "./NewsletterSignup.vue";

export default {
  name: "NewsletterPage",
  components: {
    NewsletterSignup,
  },
};
</script>

<style scoped>
.newsletter-page-container {
  background: linear-gradient(135deg, #0097a7 0%, #00838f 100%);
  min-height: calc(100vh - 64px);
  padding: 2rem 1rem;
}

.newsletter-page-content {
  max-width: 1100px;
}
</style>
